import AffiliateService from '@/services/affiliate.service';

import { Spaces } from '@fastercise/common-frontend';

const AffiliatePlanCall = Spaces.defineCall('affiliatePublicPlanCall', async affiliateCode =>
  AffiliateService.publicCode(affiliateCode)
);

export default AffiliatePlanCall;
